import type { Dispatch, FC, ReactNode, SetStateAction } from "react";
import { createContext, useContext } from "react";
import { Message } from "../../modules/message";

type ProcessContextType<T extends {} = {}> = T & {
  Request: {
    fields?: any;
    createdDateTime?: any;
    [x: string]: any;
  };
  comment: string;
  setComment: Dispatch<SetStateAction<string>>;
  approvalType: number;
  approvalStep: number;
  updatePin?: (isPin: boolean) => void;
  isPin?: () => boolean;
};

const ProcessContext = createContext<ProcessContextType>({
  Request: {},
  comment: "",
  setComment: () => "",
  approvalType: NaN,
  approvalStep: NaN,
  updatePin: () => {},
  isPin: () => false,
});
interface ProcessProps {
  context: ProcessContextType;
  children: ReactNode;
  isHideUI?: boolean;
}

const ProcessContextProvider: FC<ProcessProps> = (props) => {
  const { context, children, isHideUI = false } = props;

  if (!context.Request) {
    return <Message type="loading" />;
  }

  if (context.Request.errorMessage) {
    return <Message type="error" message={context.Request.errorMessage} />;
  }

  return (
    <ProcessContext.Provider value={context}>
      {isHideUI ? <>{children}</> : <div className="row">{children}</div>}
    </ProcessContext.Provider>
  );
};

const useProcess = <T extends {} = {}>() => {
  const ctx = useContext<ProcessContextType<T>>(ProcessContext as any);

  if (!ctx) {
    throw new Error("useProcess must be using in ProcessContext.Provider");
  }
  return ctx;
};

export { ProcessContextProvider, useProcess };

export type { ProcessContextType };
